import { mapState, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';

export const serviceComputed = {
	...mapState('menuManagementStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('menuManagementStore', Object.keys(actions)),
	...mapMutations('menuManagementStore', Object.keys(mutations))
};
